import React, { useState, useEffect } from 'react'
import { AgentModals } from '../../../functions/agent/AgentModals'
import MyCarousel from '../../../app/MyCarousel'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'
import { type RootState } from '../../../store/store'
import { ACCESS_KEY, scanningInstructions, urlAPI } from '../../../urls'
import Icon from '../../../app/icon/Icon'
import Markdown from 'react-markdown'
import GeoForMyCustomModalForView from '../../../app/custom/customModalForView/unitsActions/GeoForMyCustomModalForView'
import FormListForMyCustomForView from '../../../app/custom/customModalForView/FormListForMyCustomForView'
import { getCurrentDubaiDateString } from '../../../functions/agent/date/getCurrentDubaiDateString'
import { DatePicker, type DatePickerProps } from 'antd'
import dayjs from 'dayjs'
import CustomFormLable from '../../../app/custom/customModalUtils/CustomFormLable'
import { nanoid } from 'nanoid'
import QueryString from 'qs'
import { getQueryUnits, unitsPopulate } from '../../../functions/shared/api/queries/getQueryUnits'
import { fetchOccupiedPlaces, publishUnitWithBuyPlace } from '../../../store/actionsCreators/unitActions/publishUnitWithBuyPlace'
import { swalJustAlertAndRedirect } from '../../../functions/swalOptions'
import { setMyDraftUnitsOpen, setMyPublishUnitsOpen } from '../../../store/slices/unitsSlice'
import { useNavigate } from 'react-router-dom'







interface BoardItem {
    amount: number;
    unit: string;
    postfix: string;
    place: number | null;
    id: number
}

interface OccupiedPlace {
    attributes: {
        PublishedPlace: number;
        PublishedDate: string
    };
}
export default function AgentPublishUnitForBricks({ unitID, row, control, errors, setValue, id, modal, viewingID, register, clearErrors, trigger }: any) {
    const dispatch = useAppDispatch();
    const units = useAppSelector((state: RootState) => state.units.units);
    const navigate = useNavigate();
    const [data, setData] = useState(getCurrentDubaiDateString());
    const [selectedBoard, setSelectedBoard] = useState<string | null>(null);
    const [occupiedPlaces, setOccupiedPlaces] = useState<OccupiedPlace[]>([]);
    const dateFormat = 'YYYY-MM-DD';
    console.log(occupiedPlaces, "occupiedPlaces")
    // Определяем переменную board
    const board: BoardItem[] = [
        {
            amount: 100,
            unit: 'Bricks',
            id: 1,
            postfix: '1st position — 100 BRICKS',
            place: 1,
        },
        {
            amount: 50,
            unit: 'Bricks',
            postfix: '2nd position — 50 BRICKS',
            place: 2,
            id: 2,
        },
        {
            amount: 40,
            unit: 'Bricks',
            postfix: '3rd position — 40 BRICKS',
            place: 3,
            id: 3,
        },
        {
            amount: 30,
            unit: 'Bricks',
            postfix: '4th position — 30 BRICKS',
            place: 4,
            id: 4,
        },
        {
            amount: 20,
            unit: 'Bricks',
            postfix: '5th position — 20 BRICKS',
            place: 5,
            id: 5,
        },
        {
            amount: 0,
            unit: 'Bricks',
            id: 10,
            postfix: 'After all units position — Free',
            place: 0,
        },
    ];

    useEffect(() => {
        const loadOccupiedPlaces = async (): Promise<void> => {
            const dataOccupiedPlaces = await fetchOccupiedPlaces(data);
            console.log(dataOccupiedPlaces, "dataOccupiedPlaces")
            if (dataOccupiedPlaces?.response?.data) {
                setOccupiedPlaces(dataOccupiedPlaces?.response?.data);

            }

        };
        loadOccupiedPlaces();
    }, [data]);

    const onChange: DatePickerProps['onChange'] = (date, dateString) => {
        setData(dateString as string);
        setSelectedBoard(null);
    };

    console.log(occupiedPlaces, " <<<< occupiedPlaces <<<<<<<<")

    return (
        <>
            <div className={'px-2 mt-2 mb-8'}>
                <h1 className={'text-center my-2'}>Publish Your Unit</h1>
                <div className="mb-4">
                    <div className={'rounded rounded-sm bg-gray-300 p-4'}>
                        <label className={'form-label fw-bold fs-5 text-dark m-0 d-flex align-items-center text-uppercase'}>
                            <Icon name={'help'} className={'fs-2x text-info me-1'} />
                            Instruction
                        </label>
                        <div className='fw-semi fs-5 lh-1 mt-2'>
                            <Markdown>
                                When you publish your unit, it becomes visible to a broader audience of agents for 24 hours. This increased exposure allows other agents to see your unit and potentially respond with interest. As a result, more agents will be aware of your listing, which can lead to additional viewings and a higher chance of finding the right match for your property.
                            </Markdown>
                        </div>
                    </div>
                </div>
            </div>
            <label htmlFor="date_viewing" key={'lable_date_viewing'} className={'required form-label mt-3 fs-1x fw-bold text-uppercase'}>
                Date of publish
            </label>
            <DatePicker
                onFocus={(e) => { e.target.blur(); }}
                disabledDate={(date) => date.isBefore(dayjs(), 'day')}
                popupClassName="full-screen"
                defaultValue={dayjs(data, dateFormat)}
                className="d-block mb-4"
                size={'large'}
                name={"PublishedDate"}
                onChange={onChange}
                allowClear={false}
            />
            <div className="d-flex flex-column g-0">
                {data &&
                    board.map((value: BoardItem) => {
                        const isOccupied = occupiedPlaces?.some(

                            (place) => {
                                const publishedDate = dayjs(place?.attributes?.PublishedDate).format('YYYY-MM-DD');
                                return place?.attributes?.PublishedPlace === value?.place && publishedDate === data;
                            }
                        );


                        console.log(isOccupied, "isOccupied")
                        return (
                            <div
                                key={value.postfix + nanoid()}
                                className={`col btn fs-7 btn-light-success ml-1 mt-1 ${isOccupied ? 'btn-light-danger active' : ''}`}
                                onClick={() => { !isOccupied && setSelectedBoard(value.postfix); }}
                            >
                                {value.postfix}
                                {!isOccupied && selectedBoard === value.postfix && (
                                    <button
                                        className='col btn fs-7 btn-bso ml-1 mt-1 w-30 mx-4 text-end py-2'
                                        onClick={async () => {

                                            //   const sendObject = { email: currentUser.email, id: Number(strapiProductID), collection, collectionID, quantity, testing , areas : options?.areas}
                                            //         const response = await fetch(`${URL_MAIN_API_APP}/payment/createInvoice`, {
                                            //             method: 'POST',
                                            //             headers: {
                                            //                 'Content-Type': 'application/json',
                                            //                 Authorization: `Bearer ${jwt}`
                                            //             },
                                            //             body: JSON.stringify(sendObject)
                                            //         })
                                            //         const dataJSON = await response.json()
                                            const published = await dispatch(publishUnitWithBuyPlace(Number(unitID), value.place, data));
                                            if (published.isSuccessful) {
                                                void swalJustAlertAndRedirect(published.textNotification).then(async (result: any) => {
                                                    if (result.isConfirmed) {
                                                        dispatch(setMyDraftUnitsOpen(false));
                                                        dispatch(setMyPublishUnitsOpen(true));
                                                        navigate(`/agent/my_units`);
                                                    }
                                                });
                                            }
                                        }}
                                    >
                                        To Buy
                                    </button>
                                )}
                            </div>
                        );
                    })}
            </div>
        </>
    );
}